/**
 * It scrolls to the element with the given target selector, with an optional offset.
 *
 * @param target - The selector (usually an "id") of the element to scroll to.
 * @param offset - The offset to apply to the scroll position.
 * @param onComplete - Optional callback that will be called when the scroll animation completes. Notice that if the target element is not found, the callback will not be called.
 */
export const scrollTo = (
  target: string,
  offset = 0,
  onComplete?: () => void,
): void => {
  const element = document.querySelector<HTMLElement>(target)

  if (!element) {
    return
  }

  if (onComplete) {
    document.addEventListener('scrollend', onComplete, { once: true })
  }

  const bodyRect = document.body.getBoundingClientRect().top
  const elementRect = element.getBoundingClientRect().top
  const offsetPosition = elementRect - bodyRect - offset

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  })
}
